import { Link, LinkProps } from '@/components/atoms/Link';
import { ButtonVariants } from '@/components/atoms/legacy/Button';
import { useAnalytics } from '@/components/molecules/AnalyticsProvider';
import { AnalyticsEvent } from '@/lib/handleActionTracking';
import { Component } from '@/types/interfaces';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import React from 'react';

interface ButtonLinkProps extends Component, LinkProps {
  variant?: ButtonVariants;
  loading?: boolean;
  children: React.ReactNode;
  showButtonLinkIcon?: boolean;
  onClick?: () => void;
  analyticsEvent?: AnalyticsEvent;
}

/** @deprecated
 * Use the non-legacy `ButtonLink` component instead.
 */
const ButtonLink: React.FC<ButtonLinkProps> = ({
  className = '',
  variant = ButtonVariants.Default,
  loading = false,
  children,
  showButtonLinkIcon = true,
  onClick = () => {},
  analyticsEvent,
  ...props
}) => {
  const { handleActionTracking } = useAnalytics();
  return (
    <Link
      className={`button group ${variant} ${className}`}
      data-loading={loading}
      onClick={() => {
        if (analyticsEvent) {
          handleActionTracking(analyticsEvent);
        }
        onClick();
      }}
      {...props}
    >
      <span className="relative">
        {children}
        {variant !== ButtonVariants.Tertiary && showButtonLinkIcon && (
          <ChevronRightIcon className="absolute left-full top-1/2 translate-x-0 translate-y-[-50%] opacity-0 transition-all group-hover:translate-x-[100%] group-hover:opacity-100 group-focus:translate-x-[100%] group-focus:opacity-100" />
        )}
      </span>
    </Link>
  );
};

export default ButtonLink;
